module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }